// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import { useEffect, useLayoutEffect } from 'react';

export const useMeasureRoute = (span) => {
  useLayoutEffect(() => {
    if (span.ended !== true) {
      span.addEvent('before-render');
    }
  }, []);
};

export const useMeasureRender = (span) => {
  useLayoutEffect(() => {
    if (span.ended !== true) {
      span.addEvent('before-paint');
    }
  }, []);
};

export const useMeasurePaint = (span) => {
  useEffect(() => {
    if (span.ended !== true) {
      span.addEvent('after-paint');
      span.end();
    }
  }, []);
};
